import React from "react";
import cn from "../../lib/utils/class-name";
import { Badge, Flex, Text } from "rizzui";

const statusColors = {
  success: ["text-[#00A861]", "bg-green-dark", "bg-[#2FCA8C1A]"],
  warning: ["text-orange-dark", "bg-orange-dark"],
  danger: ["text-[#E63946]", "bg-red-dark", "bg-[#C0303A1A]"],
  paused: ["text-[#FFBF00]", "bg-red-dark", "bg-[#FFBF002A]"],
  queued: ["text-[#808080]", "bg-red-dark", "bg-[#80808033]"],
  default: ["text-gray-400", "bg-gray-600", "bg-[#D9D9D9FF]"],
};

const allStatus = {
  booked: statusColors.success,
  no_booking: statusColors.danger,
  succesful: statusColors.success,
  declined: statusColors.danger,
  stopped: statusColors.danger,
  paused: statusColors.paused,
  pending: statusColors.warning,
  paid: statusColors.success,
  completed: statusColors.success,
  approved: statusColors.success,
  active: statusColors.success,
  in_complete: statusColors.danger,
  credit: statusColors.success,
  debit: statusColors.danger,
  queued: statusColors.queued,
  failed: statusColors.danger,
};

export type StatusTypes = keyof typeof allStatus;

export function getStatusBadge(status: string) {
  const statusLower = status.toLowerCase().replaceAll(" ", "_") as StatusTypes;
  if (statusLower in allStatus) {
    return (
      <Flex
        align="center"
        gap="2"
        className={cn(
          "min-w-[30px] p-[4px] rounded-[4px]",
          allStatus[statusLower][2]
        )}
      >
        <Text
          className={cn(
            "w-full capitalize text-center font-switzer text-[12px] font-[400]",
            allStatus[statusLower][0]
          )}
        >
          {status}
        </Text>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap="2" className="w-auto">
      <Badge renderAsDot className="bg-gray-600" />
      <Text className="font-medium capitalize text-gray-600">
        {statusLower}
      </Text>
    </Flex>
  );
}
